module.exports = __webpack_public_path__ + "06018f63ce52c8c6da72be6d4fc6ef01.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-26.png
// module id = 2257
// module chunks = 0